import React from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

import MaintenancePage from './pages/MaintenancePage';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import Patient from './pages/PatientInfo';
import AddUser from './pages/AddUser';
import CreateActivity from './pages/CreateActivity';
import ActivityInfo from './pages/ActivityInfo';
import {AppProvider} from "./AppContext";

function App() {
    const isMaintenanceMode = false;
    
    return (
        <AppProvider>
            <Router>
                <Routes>
                    {isMaintenanceMode ? (
                        <Route path="*" element={<MaintenancePage />} />
                    ) : (
                        <>
                            <Route path="/" element={<Navigate to="/login" replace />} />
                            
                            <Route path='/login' element={<LoginPage />} />
                            <Route path='/home' element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
                            <Route path='/add-user' element={<ProtectedRoute><AddUser /></ProtectedRoute>} />
                            <Route path='/create-activity' element={<ProtectedRoute><CreateActivity /></ProtectedRoute>} />
                            <Route path='/patient-info/:patientId/:patientUsername' element={<ProtectedRoute><Patient /></ProtectedRoute>} />
                            <Route path='/activity-info/:activityId' element={<ProtectedRoute><ActivityInfo /></ProtectedRoute>} />
                        </>
                    )}
                </Routes>
            </Router>
        </AppProvider>
    );
}

export default App;